<script>
    import {millisecondsToArray} from "../../lib/lib";

    export let duration = 0;

    export let size = 'lg';
    export let hideSeconds = false;

    let hours = '';
    let minutes = '';
    let seconds = '';


    $: if (duration > 0) {
        [hours, minutes, seconds] = millisecondsToArray(duration);
    } else {
        hours = '00';
        minutes = '00';
        seconds = '00';
    }
</script>

<div class="duration" class:fs-5={size == 'lg'}>
    <span class:gray={ hours === '00' }>{ hours }:</span><span
        class:gray={ hours === '00' && minutes === '00' }>{ minutes }:</span><span
        class:gray={ hours === '00' && minutes === '00' && seconds === '00' } class:hidden={hideSeconds}>{ seconds }</span>
</div>

<style>
    .duration {
        font-weight: 500;
        letter-spacing: 0;
        text-align: center;
        text-transform: full-width;
    }

    .duration .gray {
        color: #959595;
    }
</style>